import { useState } from "react";
import HerosectionHeader from "../../../../Componet/Herosection/HerosectionHeader";
import { Col, Container, Row, FormGroup, Input } from 'reactstrap';
import Modal from 'react-bootstrap/Modal';
import { useSpinner } from "../../../../context/SpinnerContext";
import useAxiosPrivate from "../../../../hooks/useAxiosPrivate";
import { isValidSSN } from "../../../../store/Utility/Helper";
import { useNavigate } from "react-router-dom";

const SsnConfiguration = () => {
    const [ssn, setSSN] = useState(null);
    const [ssnConfirmModal, showSSNConfirmModal] = useState({ show: false, ssn: null });
    const [modal, showModal] = useState({ show: false, message: null });
    const axiosPrivate = useAxiosPrivate();
    const { showLoader, hideLoader } = useSpinner();
     const navigate = useNavigate();

    const onSaveSSN = async (e) => {
        e.preventDefault();
        if (!isValidSSN(ssn)) { return;}//errors.ssn = "Please enter valid Social Security Number" }
        showLoader();
        await axiosPrivate.post(`v1/inspector/save-ssn`,
            JSON.stringify(ssn)
        )
            .then(res => {
                if (res.data.data) {
                     navigate("/dashboard");
                }
                hideLoader();
            }).catch(error => {
                hideLoader();
                showSSNConfirmModal({ show: false });
                showModal({ show: true, message: error.response.data.Error });
            });
    }

    const handleClose = () => showModal({ show: false, message: null });

    const handleChange = (e) => {
        let value = e.target.value.replace(/\D/g, ''); // remove non-digits

        if (value.length > 9) {
            value = value.slice(0, 9);
        }

        let formatted = value;
        if (value.length > 5) {
            formatted = `${value.slice(0, 3)}-${value.slice(3, 5)}-${value.slice(5)}`;
        } else if (value.length > 3) {
            formatted = `${value.slice(0, 3)}-${value.slice(3)}`;
        }

        setSSN(formatted);
    };

    const maskSSN = (ssn) => {
        return ssn.replace(/^\d{3}-\d{2}/, '***-**');
    }

    return (<>
        {<Modal show={modal.show} onHide={handleClose} centered>
            <Modal.Header closeButton>
                <Modal.Title>Result</Modal.Title>
            </Modal.Header>
            <Modal.Body>{modal.message}</Modal.Body>
            <Modal.Footer>
                <button className="btn btn-dark" onClick={handleClose}>Close</button>
            </Modal.Footer>
        </Modal>}
        {<Modal show={ssnConfirmModal.show} onHide={() => showSSNConfirmModal({ show: false })} centered>
            <Modal.Header closeButton>
                <Modal.Title>Verify SSN</Modal.Title>
            </Modal.Header>
            <Modal.Body>Please confirm you provided the correct SSN: {ssn ? maskSSN(ssn) : ''}</Modal.Body>
            <Modal.Footer>
                <button className="btn btn-dark" onClick={() => showSSNConfirmModal({ show: false })}>Close</button>
                <button className="btn btn-danger" onClick={onSaveSSN}>Confirm</button>
            </Modal.Footer>
        </Modal>}
        <HerosectionHeader folder1={"pages"} folder2={"Company"} name={"Complete Your Verification"} />
        <div className="page-wrapper">
            <div className="page-content">

                <section>
                    <Container>
                        <Row>
                            <Col lg={12} md={12}>
                                <div className="checkout-form border p-4 rounded">
                                    <h2 className="mb-4">SSN Verification</h2>
                                    <div className="col-lg-12 col-12">
                                        <p className="lead mb-5">To proceed, we need to verify your identity for IRS reporting. Please enter your Social Security Number (SSN). Your information will be encrypted and stored securely in accordance with our company policy. We do not share your SSN with any third parties except as required by law for tax reporting. For your security, please do not complete this section on anyone else’s device or give access to others.</p>
                                    </div>
                                    <form >
                                        <Row form className='row align-items-end'>

                                            <Col md={4}>
                                                <FormGroup floating>

                                                    <Input
                                                        type="text"
                                                        id="ssn"
                                                        name="ssn"
                                                        placeholder="XXX-XX-XXXX"
                                                        value={ssn}
                                                        onChange={handleChange}
                                                    />
                                                    <label htmlFor="ssn">SSN</label>
                                                </FormGroup>
                                            </Col>
                                            <Col md={2}>
                                                <button type="button" className="btn btn-dark" disabled={!isValidSSN(ssn)} onClick={() => showSSNConfirmModal({ show: true, ssn: ssn })}>Save</button>
                                            </Col>
                                        </Row>
                                        {/* <Row>
                              <Col md={10}></Col>
                              <Col md={2}>
                               <button type="submit" className="btn btn-dark">Save</button>
                              </Col>
                            </Row> */}
                                    </form>
                                </div>
                            </Col>
                        </Row>
                    </Container>
                </section>
            </div>
        </div>
    </>

    );
}

export default SsnConfiguration;